const fmt = (n) => isFinite(n) ? new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD', maximumFractionDigits: 0 }).format(n) : '-';
const pct = (n) => isFinite(n) ? (n * 100).toFixed(1) + '%' : '-';
const el = id => document.getElementById(id);

// Fixed savings rates
const fsr = 0.3;   // Fuel saving rate
const csr = 0.15;  // Claim saving rate
const psr = 0.08;  // Premium saving rate

const inputs = ['vehicles','miles','fuelCostPerMile','claimsCount','claimSpendPerVehicle','premiumPerVehicle'];

function calc() {
  const V = +el('vehicles').value || 0;
  const M = +el('miles').value || 0;
  const FCPM = +el('fuelCostPerMile').value || 0;
  const CC = +el('claimsCount').value || 0;
  const CSPV = +el('claimSpendPerVehicle').value || 0;
  const PCPV = +el('premiumPerVehicle').value || 0;

  const fuelSpendPerVehicle = M * FCPM;
  const fuelCurrent = fuelSpendPerVehicle * V;
  const fuelSavings = fuelCurrent * fsr;
  const fuelNew = fuelCurrent - fuelSavings;

  const claimSpendPerVehicle = CSPV;
  const claimCurrent = claimSpendPerVehicle * CC;
  const claimSavings = claimCurrent * csr;
  const claimNew = claimCurrent - claimSavings;

  const premiumCurrent = PCPV * V;
  const premiumSavings = premiumCurrent * psr;
  const premiumNew = premiumCurrent - premiumSavings;

  const totalCurrent = fuelCurrent + claimCurrent + premiumCurrent;
  const totalNew = fuelNew + claimNew + premiumNew;
  const totalSavings = fuelSavings + claimSavings + premiumSavings;
  const reduction = totalCurrent ? (totalSavings / totalCurrent) : 0;

  el('fuelCurrent').textContent = fmt(fuelCurrent);
  el('fuelSavings').textContent = fmt(fuelSavings);
  el('fuelNew').textContent = fmt(fuelNew);

  el('claimCurrent').textContent = fmt(claimCurrent);
  el('claimSavings').textContent = fmt(claimSavings);
  el('claimNew').textContent = fmt(claimNew);

  el('premiumCurrent').textContent = fmt(premiumCurrent);
  el('premiumSavings').textContent = fmt(premiumSavings);
  el('premiumNew').textContent = fmt(premiumNew);

  el('totalCurrent').textContent = fmt(totalCurrent);
  el('totalSavingsCell').textContent = fmt(totalSavings);
  el('totalNew').textContent = fmt(totalNew);

  el('totalSavings').textContent = fmt(totalSavings);
  el('percentReduction').textContent = pct(reduction) + ' reduction';
}

inputs.forEach(id => el(id).addEventListener('input', calc));
window.addEventListener('DOMContentLoaded', calc);
